const config = {
  apiKey: "AIzaSyCWNrpGtbjyX9Wv17WusNCJZN46ZJU5fgA",
  authDomain: "lca-dashboard.firebaseapp.com",
  databaseURL: "https://lca-dashboard.firebaseio.com",
  projectId: "lca-dashboard",
  storageBucket: "lca-dashboard.appspot.com",
  messagingSenderId: "112878252835",
  appId: "1:112878252835:web:7f9e7098e847a2fd2a5296",
  storageBucket: 'gs://lca-dashboard.appspot.com',
};

export default config